import React from 'react';
import { Result, Button } from 'antd';
import type { FallbackProps } from 'react-error-boundary';

const ErrorFallback: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
  return (
    <Result
      status="error"
      title="データの取得に失敗しました"
      subTitle="ネットワーク接続を確認して、もう一度お試しください。"
      extra={
        <Button type="primary" onClick={resetErrorBoundary}>
          再試行
        </Button>
      }
    />
  );
};

export default ErrorFallback;
